
const bilanEndPoint = '/api/v1/bilans';

export default bilanEndPoint;
